import ButtonNavSwiper from '@/components/ButtonNavSwiper';
import SwiperCenteredSlides from '@/components/SwiperCenteredSlides';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { fulfillmentWarehouseImgData } from '../cooperateData';

export default function FulfillmentWarehouseImg() {
  return (
    <section className="overflow-hidden bg-white pt-12 pb-24">
      <h2 className="text-title32 text-neutral-90 desktop:mb-10 desktop:text-title42 desktop:pb-0 pb-6 text-center font-bold">
        Hình ảnh kho bãi
      </h2>
      <div className="relative">
        <div className="max-w-8xl desktop:px-8 absolute inset-x-auto top-1/2 z-10 mx-auto flex min-w-full -translate-y-1/2 items-center justify-between px-4">
          <ButtonNavSwiper type="left" className="col-span-1" />
          <ButtonNavSwiper type="right" className="col-span-1" />
        </div>
        <SwiperCenteredSlides
          items={fulfillmentWarehouseImgData}
          type="warehouse"
        />
      </div>
    </section>
  );
}
